const { Warning } = require("postcss");

$(document).ready(function(){
    $.when($('#overlay').fadeOut())
    .done(function() {
        $('#main-wrapper').show();
    });
    
    $('[data-toggle="tooltip"]').tooltip();
    $('.summernote').summernote({
        height: 150,
        toolbar: [
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['font', ['strikethrough']],
            ['para', ['ul', 'ol']],
            ['insert', ['link']],
            ['view', ['fullscreen', 'help']]
        ],
        callbacks: {
            onPaste: function (e) {
                var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                e.preventDefault();
                document.execCommand('insertText', false, bufferText);
            }
        }
    });
    
    $(document).on('submit', 'form:not(.loginForm)', function(){
        $('.modal').modal('hide');
        $('#loadingModal').modal('show');
        $(':submit').html('loading...').addClass('disabled').prop('disabled', true);
    });
    
    $(document).on('click', '.logout', function(){
        $(this).html('<i class="fa fa-spinner fa-spin" aria-hidden="true"></i>').addClass('disabled').prop('disabled', true);
        document.getElementById('logout-form').submit();
    });
    
    $(document).on('click', ".scrollto", function() {
        var scrollto = $(this).attr('scrollto');
        var offset = $(this).attr('offset');
        $('html, body').animate({
            scrollTop: $("#"+scrollto).offset().top -offset
        }, 1000);
    });
    
    $(document).on('click', ".jplist-pagination button, .jplist-pagesbox button", function() {
        $('html, body').animate({
            scrollTop: $(".list-top").offset().top -100
        }, 1000);
    });
    
    $(document).on('click', ".datepicker-btn", function() {
        var datepicker = $(this).attr('datepicker');
        $('#'+datepicker).focus();
    });
    
    // clear error messgaes
    $(document).on('change', '.form-control, .custom-control-input, .custom-file-input, input', function() {
        $(this).closest(".is-invalid").removeClass('is-invalid');
        $(this).closest(".input-group.is-invalid").removeClass('is-invalid');
        $('.toast-close-button').click();
    });
    $(".chosen-select").chosen().change(function() {
        $(this).removeClass('is-invalid');
        $('.toast-close-button').click();
    });

    // escape html code
    $('.decode').each(function() {
        var val = $(this).text();
        $(this).html(htmlDecode(val));
    });

    // escape html code for forms
    $('.form-control').each(function() {
        var val = $(this).val();
        $(this).val(htmlDecode(val));
    });

    // filter table
    $(document).on('change', '.filter:not(#statusFormDetails, [name="example1_length"], [aria-controls="example1"]), .filter-check', function() {
        filterchips();
        jplistcheck();
    });
    $(document).on('keyup', '.filter.keyup:not(#statusFormDetails, [name="example1_length"], [aria-controls="example1"])', function() {
        filterchips();
        jplistcheck();
    });

    // remove chips and clear filter
    $(document).on('click', '.chipclose', function() {
        var id = $(this).attr('filter');
        $('#'+id).val('');
        $(this).parent().remove();
        $('.filter.keyup').keyup();
    });
    $(document).on('click', '.chipcheckclose', function() {
        var id = $(this).attr('filter');
        id = escapeSelector(id);
        $('#'+id).prop('checked', false);
        $(this).parent().remove();
        $('.filter.keyup').keyup();
    });

    //input mask for phone number
    $(document).on('keydown change', '.phoneMask', function(e) {
        setTimeout(() => {
            var phoneNumber = e.target.value.replace(/\D/g, '');
            // console.log(e.target.value, phoneNumber.length)
            
            if (phoneNumber.length <= 3) {
                e.target.value = phoneNumber;
            } else if (phoneNumber.length <= 6) {
                e.target.value = phoneNumber.slice(0, 3) + '-' + phoneNumber.slice(3);
            } else if (phoneNumber.length <= 10) {
                e.target.value = phoneNumber.slice(0, 3) + '-' + phoneNumber.slice(3, 6) + '-' + phoneNumber.slice(6);
            } else {
                e.target.value = phoneNumber.slice(0, 3) + '-' + phoneNumber.slice(3, 6) + '-' + phoneNumber.slice(6, 10);
            }
            
        }, 100);
    });
});

(function() {
    'use strict';
    window.addEventListener('load', function() {
        var forms = document.getElementsByClassName('needs-validation');
        var validation = Array.prototype.filter.call(forms, function(form) {
            form.addEventListener('submit', function(event) {
                $('.form-control, .custom-file-input, .custom-control-input').each(function (i, e) {
                    if ($(this).is(":invalid")) {
                        $(this).closest(".input-group, .chosen-select, .custom-control-group").addClass('is-invalid');
                    }
                });
                if ((typeof validateform == 'function' && validateform() === false) || form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                    failure('Form has errors');
                    
                    $('html, body').animate({
                        scrollTop: $('.is-invalid:visible:first').offset().top -100
                    }, 300);
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();

// add chips when filter applied
function filterchips() {
    $('.chips').remove();
    $(".filter").each(function(){
        var val = $(this).val();
        // console.log(val);
        if (val) {
            $('#chipsrow').append('<span class="label label-danger chips">'+ $(this).attr('label') +': '+ val +' <button class="btn btn-xs btn-link chipclose" filter="'+ $(this).prop('id') +'">x</button></span>');
        }
    });
    $(".filter-check:checked").each(function(){
        var val = $(this).next('label').text();
        // console.log(val);
        if (val) {
            $('#chipsrow').append('<span class="label label-danger chips">'+ $(this).attr('label') +': '+ val +' <button class="btn btn-xs btn-link chipcheckclose" filter="'+ $(this).prop('id') +'">x</button></span>');
        }
    });
}

function hasUppercase(string) {
    var regex= new RegExp('[A-Z]');
    return string.match(regex) != null;
}

function hasLowercase(string) {
    var regex= new RegExp('[a-z]');
    return string.match(regex) != null;
}

function hasNumber(string) {
    var regex= new RegExp('[0-9]');
    return string.match(regex) != null;
}

function hasSpecialChar(string) {
    return /[\s~`!@#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?()\._]/g.test(string);
}

function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

function isValidDate(dateString) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if(!dateString.match(regEx)) return false;  // Invalid format
    var d = new Date(dateString);
    var dNum = d.getTime();
    if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
    return d.toISOString().slice(0,10) === dateString;
}

function formatDate(date) {
    var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
    
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    
    return [year, month, day].join('-');
}

function formatTime(date) {
    var d = new Date(date),
    h = '' + d.getHours(),
    m = '' + d.getMinutes();
    
    if (h.length < 2) h = '0' + h;
    if (m.length < 2) m = '0' + m;
    
    return [h, m].join(':');
}

// setup ajax
$.ajaxSetup({
    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
});
var xhr;

$(document).on('click', '.jplist-panel, .filter-name-item, .datepicker ', function() {
    jplistcheck();
});

function jplistcheck() {
    setTimeout(() => {
        // console.log($('.row.list').hasClass('jplist-hidden'))
        if ($('.list').hasClass('jplist-hidden')) {
            $('.empty').removeClass('hide');
        } else {
            $('.empty').addClass('hide');
        }
    }, 300);
}

function htmlDecode(input){
    var e = document.createElement('textarea');
    e.innerHTML = input;
    // handle case of empty input
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
}
